module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_7016.1142a0e2.png";